import React, { Component } from "react";
import UserList from './UserList'
import Config from './Config'
 
class Vendor extends Component {
  
  render() {
    return (
      <UserList config={Config.vendor}/>
    );
  }
}
 
export default Vendor;


// WEBPACK FOOTER //
// ./src/js/Vendor.js